/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['boxInfoMsg', 'boxErrorMsg'] }] */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { cn } from 'helpers/classnames';
import { AriaLiveTee } from 'components/common/AriaLive';
import { getReissuablePromos, trackMetric } from 'utils/zaw';
import { ZawSubsidyReissueEligibility } from 'constants/zaw';
import { ZAW_RETURN_SCENARIO } from 'constants/amethystEnums';

import css from 'styles/containers/returns/refundSummaryMessage.scss';

const ZawRefundSummaryMessage = ({ visible, zawSubsidyReissueEligibility, phoneNumber, subsidyAmount, promotions, returnStep }) => {
  const [metricAlreadyEmitted, setMetricAlreadyEmitted] = useState(false);
  const trackMetricOnce = event => {
    if (!metricAlreadyEmitted) {
      setMetricAlreadyEmitted(true);
      trackMetric({ step: returnStep, ...event });
    }
  };

  if (!visible || !zawSubsidyReissueEligibility) {
    return null;
  }

  switch (zawSubsidyReissueEligibility) {
    case ZawSubsidyReissueEligibility.SUBSIDY_EXPIRED_NOT_REISSUED:
      trackMetricOnce({
        scenario: ZAW_RETURN_SCENARIO.SUBSIDY_EXPIRED_NOT_REISSUED
      });
      return (
        <div>
          <div className={cn(css.blockErrorMsg, css.blockMsg)}>
            <AriaLiveTee>
              <strong>†</strong> Your Zappos at Work Subsidy will NOT be re-issued to your account.
            </AriaLiveTee>
          </div>
          <Link className={css.faqLink} to={'/c/zaw-amazon-faq'}>
            Refer to our FAQ for more information
          </Link>
        </div>
      );
    case ZawSubsidyReissueEligibility.RETURN_NEEDED:
      trackMetricOnce({
        scenario: ZAW_RETURN_SCENARIO.RETURN_NEEDED
      });
      return (
        <div className={cn(css.blockInfoMsg, css.blockMsg)}>
          <AriaLiveTee>
            <strong>†</strong> To have your Zappos at Work subsidy re-issued on your account, please return the previously returned item.
          </AriaLiveTee>
        </div>
      );
    case ZawSubsidyReissueEligibility.SUBSIDY_WILL_BE_REISSUED:
      const reissuableZawPromos = getReissuablePromos(promotions);
      trackMetricOnce({
        scenario: ZAW_RETURN_SCENARIO.SUBSIDY_CAN_BE_REISSUED,
        reissuableZawPromos
      });
      return (
        <div className={cn(css.blockInfoMsg, css.blockMsg)}>
          <AriaLiveTee>
            <strong>†</strong> Your Zappos At Work Subsidy of <strong>{subsidyAmount}</strong> will be reissued onto your Zappos account.
          </AriaLiveTee>
        </div>
      );
    case ZawSubsidyReissueEligibility.SUBSIDY_EXPIRED:
      trackMetricOnce({
        scenario: ZAW_RETURN_SCENARIO.SUBSIDY_CANNOT_BE_REISSUED_REASON_EXPIRED
      });
      return (
        <div className={cn(css.blockErrorMsg, css.blockMsg)}>
          <AriaLiveTee>
            <strong>†</strong> Your Zappos at Work subsidy of <strong>{subsidyAmount}</strong> cannot be reissued onto your account since it’s
            expired. Need help with this return? Contact us at <strong>{phoneNumber}</strong>.
          </AriaLiveTee>
        </div>
      );
    case ZawSubsidyReissueEligibility.ORDER_CONTAINS_MULTIPLE_ITEMS:
      trackMetricOnce({
        scenario: ZAW_RETURN_SCENARIO.SUBSIDY_CANNOT_BE_REISSUED_REASON_MULTI_ITEM_ORDER
      });
      return <FallbackZawMessage phoneNumber={phoneNumber} />;
    default:
      trackMetricOnce({
        scenario: ZAW_RETURN_SCENARIO.SUBSIDY_CANNOT_BE_REISSUED_REASON_OTHER
      });
      return <FallbackZawMessage phoneNumber={phoneNumber} />;
  }
};

const FallbackZawMessage = ({ phoneNumber }) => (
  <div className={cn(css.blockErrorMsg, css.blockMsg)}>
    <AriaLiveTee>
      <strong>†</strong> To have your Zappos At Work Subsidy reissued onto your account, contact us at <strong>{phoneNumber}</strong>.
    </AriaLiveTee>
  </div>
);

export default ZawRefundSummaryMessage;
